<template>
  <!-- footer section -->
  <footer class="footer">
    <v-container>
      <v-row class="text-center">
        <v-col>
          <ul class="list-unstyled">
            <li>
              <p class="footerLinksHeader">
                <strong>{{ $t("About Us") }}</strong>
              </p>
            </li>
            <li>
              <router-link to="/about" class="footer-link">
                {{ $t("About Us") }}</router-link
              >
            </li>
            <li>
              <router-link to="/contactus" class="footer-link">
                {{ $t("Contact Us") }}</router-link
              >
            </li>
            <li>
              <router-link to="/policy" class="footer-link">
                {{ $t("Website Policy") }}</router-link
              >
            </li>
            <li>
              <router-link to="/terms" class="footer-link">
                {{ $t("Term of Use") }}</router-link
              >
            </li>
          </ul>
        </v-col>
        <v-col>
          <ul class="list-unstyled">
            <li>
              <p class="footerLinksHeader">
                <strong>{{ $t("Store") }}</strong>
              </p>
            </li>
            <li>
              <router-link to="/market" class="footer-link">
                {{ $t("Store") }}</router-link
              >
            </li>
            <!-- <li>
              <router-link to="/contactus" class="footer-link">
                {{ $t("My Orders") }}</router-link
              >
            </li>
            <li>
              <router-link to="/policy" class="footer-link">
                {{ $t("Track Order") }}</router-link
              >
            </li> -->
            <li
              v-if="type == 'Teacher' || type == 'Student' || type == 'Market'"
              style="display: none"
            >
              <router-link to="/market/wishlist" class="footer-link">
                {{ $t("wishlist") }}</router-link
              >
            </li>
            <li style="display: none">
              <router-link to="/seller/registration" class="footer-link">
                {{ $t("Start Selling with Jawab") }}</router-link
              >
            </li>
          </ul>
        </v-col>
        <v-col v-if="type">
          <ul class="list-unstyled">
            <li>
              <p class="footerLinksHeader">
                <strong>{{ $t("Profile") }}</strong>
              </p>
            </li>
            <li v-if="type == 'Teacher' || type == 'Student'">
              <router-link
                :to="
                  type == 'Teacher' ? '/teacher/profile' : '/student/profile'
                "
                class="footer-link"
              >
                {{ $t("Profile") }}</router-link
              >
            </li>
            <li v-if="type == 'Teacher' || type == 'Student'">
              <router-link
                class="footer-link"
                :to="
                  type == 'Student'
                    ? '/student/appointments'
                    : type == 'Teacher'
                    ? '/teacher/appointments'
                    : ''
                "
              >
                {{ $t("My Appointments") }}</router-link
              >
            </li>
            <li v-if="type == 'Student'">
              <router-link to="/student/wallet" class="footer-link">
                {{ $t("Wallet") }}</router-link
              >
            </li>
            <li v-if="type == 'Student'">
              <router-link to="/teachers" class="footer-link">
                {{ $t("Teachers") }}</router-link
              >
            </li>
            <li
              v-if="type == 'Teacher' || type == 'Student' || type == 'Market'"
            >
              <router-link
                :to="
                  type == 'Teacher'
                    ? '/teacher/profilesettings'
                    : type == 'Student'
                    ? '/student/profilesettings'
                    : '/market/profilesettings'
                "
                class="footer-link"
              >
                {{ $t("Account Settings") }}</router-link
              >
            </li>
          </ul>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2" sm="2">
          <img src="../assets/images/MOELogo.png" alt />
        </v-col>
        <v-col cols="8" sm="8">
          <div class="socialIcons text-center">
            <p class="text-center social-title">
              {{ $t("Follow Us") }}
            </p>
            <a
              v-if="socialData.facebook_link"
              :href="socialData.facebook_link"
              target="_blank"
            >
              <i class="fab fa-facebook-f"></i>
            </a>
            <a
              v-if="socialData.linkedin_link"
              :href="socialData.linkedin_link"
              target="_blank"
            >
              <i class="fab fa-linkedin"></i>
            </a>
            <a
              v-if="socialData.twitter_link"
              :href="socialData.twitter_link"
              target="_blank"
            >
              <i class="fab fa-twitter"></i>
            </a>
            <a
              v-if="socialData.instagram_link"
              :href="socialData.instagram_link"
              target="_blank"
            >
              <i class="fab fa-instagram"></i>
            </a>
            <a
              v-if="socialData.snapchat_link"
              :href="socialData.snapchat_link"
              target="_blank"
            >
              <i class="fab fa-snapchat"></i>
            </a>
          </div>
        </v-col>

        <v-col cols="2" sm="2">
          <img src="../assets/images/vision-logo.png" alt />
        </v-col>
      </v-row>
    </v-container>
  </footer>
</template>

<script>
import AUTH from "../auth";

export default {
  name: "FooterComponent",
  data() {
    return {
      socialData: {},
      type: AUTH.type(),
    };
  },
  methods: {
    getSocialMediaLinks() {
      this.$http.get(this.getApiUrl + "/social_links").then((response) => {
        if (response.data.status.error == false) {
          console.log(response.data);
          this.socialData = response.data.data;
        }
      });
    },
  },
  mounted() {
    this.getSocialMediaLinks();
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/_variables.scss";

.footer {
  background-color: $second-color !important;
  .footer-link {
    color: #ffffff !important;
    text-decoration: unset;
  }
  // margin-top: -24px;
  @media (min-width: 600px) {
    min-height: 175px;
  }
  img {
    max-width: 100% !important;
  }

  .list-unstyled {
    margin-top: 1rem !important;
    color: #ffffff;
    text-align: center;
    list-style: none;
    li {
      // display: inline-block;
      padding-left: 1rem;
      padding-right: 1rem;
    }
  }

  .socialIcons {
    margin-top: 1rem;
    .social-title {
      font-weight: bold;
      color: #ffffff;
      font-size: 1.5rem !important;
    }
    svg {
      font-size: 2rem !important;
      margin: 0 5px;
      color: #ffffff;
    }
  }
  .list-unstyled li {
    margin-bottom: 15px;
  }
}
</style>
